import styled from '@emotion/styled';

import { tableFormatPhoneNumber } from '../../../utils/utils';
import TableSliderContentWrapper from '../TableAccessories/TableSliderContentWrapper';

interface ViewBADriverInfoCompanyProps {
  data?: Record<string, any>;
}

const ViewBADriverInfoCompany: React.FC<ViewBADriverInfoCompanyProps> = ({
  data,
}) => {
  // const tableContext = useContext(TableContext);

  return (
    <TableSliderContentWrapper label='Driver Profile'>
      <Cell className='vertical'>
        <CellLabel>Image</CellLabel>
        <ImageWrapper>
          <Img src={data?.driverImage ?? ''} alt='Driver profile picture' />
        </ImageWrapper>
      </Cell>

      {/* section 1 */}
      <Section>
        <Cell>
          <CellLabel>Name</CellLabel>
          <div>{`${data?.driverName ?? '--'}`}</div>
        </Cell>
        <Cell>
          <CellLabel>Gender</CellLabel>
          <div>{data?.gender ?? '--'}</div>
        </Cell>
        <Cell>
          <CellLabel>Phone Number</CellLabel>
          <div>{tableFormatPhoneNumber(data?.phoneNumber) ?? '--'}</div>
        </Cell>
        <Cell>
          <CellLabel>Employment Type</CellLabel>
          <div>{data?.employmentType ?? '--'}</div>
        </Cell>
      </Section>
    </TableSliderContentWrapper>
  );
};

export default ViewBADriverInfoCompany;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* border: 1px solid red; */
  background-color: rgba(250, 250, 250, 0.8);
  padding: 12px;
`;

const Cell = styled.div`
  display: flex;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #2f3644;
  justify-content: space-between;

  &.vertical {
    flex-direction: column;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  padding: 8px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 8px;
  cursor: crosshair;
`;

const Img = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 8px;
  object-fit: cover;
`;

const CellLabel = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.darkGrayText};
  /* border: 1px solid blue; */
`;
